<template>
  <div class="dispatch-layout">
    <AppFooter />
    <AppHeader />
    <main class="main-content">
      <router-view v-slot="{ Component, route }">
        <transition name="fade" mode="out-in">
          <div v-if="Component" :key="route.path" class="page-view">
            <component :is="Component" />
          </div>
        </transition>
      </router-view>
    </main>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import { useAuditMenuBadge } from '@/composables/useAuditMenuBadge'

const { startAuditRemind, stopAuditRemind } = useAuditMenuBadge()

onMounted(() => {
  startAuditRemind()
})

onUnmounted(() => {
  stopAuditRemind()
})
</script>

<style scoped>
.dispatch-layout {
  min-height: 100vh;
  background: var(--bg-page);
}

.main-content {
  margin-top: var(--header-height);
  margin-left: var(--sidebar-width);
  min-height: calc(100vh - var(--header-height));
}

.page-view {
  min-height: inherit;
}
</style>
